import { render, staticRenderFns } from "./UserRolesDropdown.vue?vue&type=template&id=43e47077&"
import script from "./UserRolesDropdown.vue?vue&type=script&lang=js&"
export * from "./UserRolesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports